import React, { useContext, useEffect } from 'react'
import { View } from 'react-native'
import { StackScreenProps } from '@react-navigation/stack'
import { AuthContext } from '../../../contexts/auth-context'
import { AppNavigatorParams } from '../../../navigation/types'
import { ScreenWrapper } from '../../../@ui/containers/grid/screen.wrapper'
import { Copyright } from '../../../@ui/typo/copyright.typo'
import { useGlobalStyles } from '../../../contexts/global-styles.provider'
import { RegisterForm } from './register.form'
import { goAfterLogin } from '../login/utils'
import { useTheme } from '../../../hooks/theme.hook'

export function RegisterScreen({
  navigation,
  route: { params },
}: StackScreenProps<AppNavigatorParams, 'Register'>) {
  const authCtx = useContext(AuthContext)
  const globalStyles = useGlobalStyles()
  const theme = useTheme()
  const returnPath = params?.returnPath || ''

  useEffect(() => {
    if (!authCtx.isAnonymous) {
      goAfterLogin({ navigation, returnPath })
      return
    }
  }, [authCtx.isAnonymous, returnPath])

  return (
    <View style={{ flex: 1 }}>
      <ScreenWrapper
        contentContainerStyle={{
          ...globalStyles.pageContainer,
          padding: theme.spacing(4),
        }}
      >
        <RegisterForm
          initialMobileNumber={params?.mobileNumber}
          initialCountryCode={params?.mobileCountryCode}
          returnPath={returnPath}
        />
      </ScreenWrapper>
      <Copyright />
    </View>
  )
}
